import html2pdf from 'html2pdf.js';

export function exportToPDF(elementId, filename = 'resume.pdf') {
	const element = document.getElementById(elementId);
	if (!element) return Promise.reject(new Error('Preview element not found'));
	const opt = {
		margin: [0.5, 0.5, 0.5, 0.5],
		filename,
		image: { type: 'jpeg', quality: 0.98 },
		html2canvas: { scale: 2, useCORS: true },
		jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
	};
	return html2pdf().from(element).set(opt).save();
}


